// Resolve a status string against a style map (see statusStyles.js).
// Matching is case/space insensitive so "Partially Paid" resolves to the
// `partiallyPaid` key. Falls back to the map's `unknown` entry when missing.
export function resolveStatusStyle(map, status) {
  const fallback = map?.unknown ?? {
    label: "Unknown",
    color: "bg-[#F3F4F6] text-[#4B5563]",
  };

  if (!status || !map) return fallback;

  const normalized = String(status).toLowerCase().replace(/[\s_-]+/g, "");
  const entry = Object.entries(map).find(
    ([key]) => key.toLowerCase().replace(/[\s_-]+/g, "") === normalized
  );

  return entry ? map[entry[0]] : fallback;
}

// Small presentational badge used across the new back-office tables.
export function StatusBadge({ map, status, className = "" }) {
  const style = resolveStatusStyle(map, status);
  return (
    <span
      className={`inline-block px-2 py-1 rounded-md text-xs font-medium ${style.color} ${className}`}
    >
      {style.label}
    </span>
  );
}
